import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { FlexLayoutModule } from "@angular/flex-layout";
import { RouterModule } from "@angular/router";
import { MenuModule } from "@bfx/primeng/menu";
import { TieredMenuModule } from "@bfx/primeng/tieredmenu";
import { SplitButtonModule } from "@bfx/primeng/splitbutton";
import { PanelMenuModule } from "@bfx/primeng/panelmenu";
import { OverlayPanelModule } from "@bfx/primeng/overlaypanel";

import { BfxElementsLibraryModule } from "../bfx-element-library/bfx-elements-library.module";
import { BfxApplicationNotificationModule } from "../bfx-notification-application/bfx-application-notification.module";
import { BfxNavMenuComponent } from "./bfx-nav-menu.component";
import { BfxDashboardMenuComponent } from "./bfx-dashboard-menu.component";
import { BfxNewOrderMenuComponent } from "./bfx-neworder-menu.component";
import { BfxViewsMenuComponent } from "./bfx-views-menu.component";
import { BfxUserMenuComponent } from "./bfx-user-menu.component";
import { BfxBlotterSettingsMenuComponent } from "app/bfx-menus/bfx-blotter-settings-menu.component";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BaseComponentsModule } from "../../shared/base-components/base-components.module";
import { BrandingComponentsModule } from "shared/branding/branding-components.module";

@NgModule({
  declarations: [
    BfxBlotterSettingsMenuComponent,
    BfxNavMenuComponent,
    BfxDashboardMenuComponent,
    BfxUserMenuComponent,
    BfxNewOrderMenuComponent,
    BfxViewsMenuComponent,
  ],
  exports: [
    BfxBlotterSettingsMenuComponent,
    BfxNavMenuComponent,
    BfxDashboardMenuComponent,
    BfxNewOrderMenuComponent,
    BfxViewsMenuComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    BfxApplicationNotificationModule,
    TieredMenuModule,
    MenuModule,
    PanelMenuModule,
    NativeDesktopModule,
    BaseComponentsModule,
    SplitButtonModule,
    BrandingComponentsModule,
    OverlayPanelModule,
    BfxElementsLibraryModule,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class BfxMenusModule {}
